// extracted by mini-css-extract-plugin
module.exports = {"debug":"imageGalery_debug__tYEYi","container":"imageGalery_container__14Ruf","imageContainer":"imageGalery_imageContainer__1f2pM","image":"imageGalery_image__2ZRbc"};